import { Button, ButtonProps } from "@/components/base/button";
import ArrowLeft from "@assets/icons/arrow-left.svg?react";
import { useTranslation } from "@vixi/localization";

export interface GoBackBtnProps extends Omit<ButtonProps, "onClick"> {
  onBack: () => void;
}

export const GoBackBtn = ({ onBack, ...props }: GoBackBtnProps) => {
  const { t, isRtl } = useTranslation();

  return (
    <div className="self-center py-1.5">
      <Button
        variant="outlined"
        className="fs-19 min-w-auto gap-1 px-4 py-1"
        {...props}
        onClick={onBack}
      >
        <ArrowLeft className="size-4" style={{ transform: isRtl ? "scale(-1)" : "" }} />
        <div className="ar:mb-0.75 mb-0">{t("Action.Back")}</div>
      </Button>
    </div>
  );
};
